// Javascript for the hotspot section
// const hotSpotElement = document.querySelectorAll(".hot-spot__dot");

class HotSpot extends HTMLElement {
  constructor() {
    super();
    this.hotSpotElements = this.querySelectorAll(".hot-spot__dot"); // Scope to this instance
    this.viewportWidth = window.innerWidth;
    this.handleResize = this.handleResize.bind(this);
    this.overlay = document.querySelector(".PageOverlay");
  }

  connectedCallback() {
    // Bind click events to hot-spot dots
    this.hotSpotElements.forEach((hotSpotElement) => {
      hotSpotElement.addEventListener("click", this.handleClick.bind(this));
    });

    // Close overlay click
    if (this.overlay) {
      this.overlay.addEventListener("click", this.handleClose.bind(this));
    }

    // Resize event
    window.addEventListener("resize", this.handleResize);
  }

  handleResize() {
    this.viewportWidth = window.innerWidth;
  }

  handleClick(e) {
    const dot = e.target;
    const parent = dot.parentElement; // Parent hotspot
    const popover = parent.querySelector(".hot-spot-popover");
    const svg = parent.querySelector("svg");

    const dotPosition = dot.getBoundingClientRect();
    const halfViewportWidth = this.viewportWidth / 2;

    // Toggle popover visibility
    popover.classList.toggle("popover-visible");

    // Toggle SVG icon
    if (svg) {
      svg.classList.toggle("toggle-icon");
    }

    // Desktop logic
    if (this.viewportWidth >= 768) {
      if (popover.classList.contains("popover-bottom")) {
        popover.classList.remove("popover-bottom");
      }

      // Position left or right based on dot position
      if (dotPosition.left < halfViewportWidth) {
        popover.classList.add("popover-right");
        popover.classList.remove("popover-left");
      } else {
        popover.classList.add("popover-left");
        popover.classList.remove("popover-right");
      }
    } else {
      // Mobile logic
      this.overlay.classList.add("is-visible");
      popover.classList.add("popover-bottom");
      document.body.classList.add("no--scroll");
    }
  }

  handleClose() {
    // Close overlay
    this.overlay.classList.remove("is-visible");
    document.body.classList.remove("no--scroll");

    // Close all popovers and reset icons within this HotSpot instance
    const allPopOvers = this.querySelectorAll(".hot-spot-popover");
    const allSvgs = this.querySelectorAll(".hot-spot__dot svg");

    allPopOvers.forEach((popover) => {
      popover.classList.remove(
        "popover-bottom",
        "popover-visible",
        "popover-left",
        "popover-right"
      );
    });

    allSvgs.forEach((svg) => {
      svg.classList.remove("toggle-icon");
    });
  }

  disconnectedCallback() {
    // Clean up event listeners
    this.hotSpotElements.forEach((hotSpotElement) => {
      hotSpotElement.removeEventListener("click", this.handleClick.bind(this));
    });

    if (this.overlay) {
      this.overlay.removeEventListener("click", this.handleClose.bind(this));
    }

    window.removeEventListener("resize", this.handleResize);
  }
}

customElements.define("hot-spot", HotSpot);

// end javsscript for hotspot section

// Custom Drawer

const detailCustomMenu = document.querySelectorAll(
  ".Details-custom-menu-drawer"
);

if (detailCustomMenu.length > 0) {
  detailCustomMenu.forEach((detail) => {
    const closeIcon = detail.querySelector(".icon-close-custom");
    const summary = detail.querySelector("summary");
    const overlay = summary.querySelector(".overlay");

    let isHovered = false; // To track whether the cursor is inside the <details>
    let hoverTimer = null; // Timer variable to track and clear timeouts

    // Open menu on hover
    summary.addEventListener("mouseover", () => {
      clearTimeout(hoverTimer); // Clear any existing timer
      detail.setAttribute("open", "true");
      summary.setAttribute("aria-expanded", "true");
      document.body.classList.add("overflow-hidden");
      isHovered = true; // Mark as hovered
    });

    // Keep the menu open when inside the <details>
    detail.addEventListener("mouseenter", () => {
      clearTimeout(hoverTimer); // Clear any existing timer
      isHovered = true;
    });

    // Close menu when leaving the <details>
    detail.addEventListener("mouseleave", () => {
      isHovered = false;
      clearTimeout(hoverTimer); // Clear any existing timer
      hoverTimer = setTimeout(() => {
        if (!isHovered) {
          detail.removeAttribute("open");
          summary.setAttribute("aria-expanded", "false");
          // Only remove the class if no other menus are open
          if (!document.querySelector(".Details-custom-menu-drawer[open]")) {
            document.body.classList.remove("overflow-hidden");
          }
        }
      }, 200); // Increased timeout for smoother behavior
    });

    // Close menu on close icon click
    if (closeIcon) {
      closeIcon.addEventListener("click", (e) => {
        e.stopPropagation();
        detail.removeAttribute("open");
        detail.querySelector(".custom-sub-menu-item")?.removeAttribute("open");
        summary.setAttribute("aria-expanded", "false");
        // Only remove the class if no other menus are open
        if (!document.querySelector(".Details-custom-menu-drawer[open]")) {
          document.body.classList.remove("overflow-hidden");
        }
      });
    }

    // Close menu on overlay click
    if (overlay) {
      overlay.addEventListener("click", (e) => {
        e.stopPropagation();
        detail.querySelector(".custom-sub-menu-item")?.removeAttribute("open");
        summary.setAttribute("aria-expanded", "false");
        // Only remove the class if no other menus are open
        if (!document.querySelector(".Details-custom-menu-drawer[open]")) {
          document.body.classList.remove("overflow-hidden");
        }
      });
    }
  });
}

const detailsSubMenu = document.querySelectorAll(".custom-sub-menu-item");
if (detailsSubMenu.length > 0) {
  detailsSubMenu.forEach((detailSubMenu) => {
    const menuDrawerSubmenu = detailSubMenu.querySelector(
      ".menu-drawer__submenu"
    );

    let isHovered = false; // To track hover state for sub-menu items
    let subMenuTimer = null; // Timer variable for submenu

    // Open submenu on hover
    detailSubMenu.addEventListener("mouseover", () => {
      clearTimeout(subMenuTimer); // Clear any existing timer
      detailSubMenu.setAttribute("open", "true");
      menuDrawerSubmenu.style.visibility = "visible";
      isHovered = true; // Mark as hovered
    });

    // Keep the submenu open when inside the <details>
    detailSubMenu.addEventListener("mouseenter", () => {
      clearTimeout(subMenuTimer); // Clear any existing timer
      isHovered = true;
    });

    // Close submenu when leaving the <details>
    detailSubMenu.addEventListener("mouseleave", () => {
      isHovered = false;
      clearTimeout(subMenuTimer); // Clear any existing timer
      subMenuTimer = setTimeout(() => {
        if (!isHovered) {
          detailSubMenu.removeAttribute("open");
          menuDrawerSubmenu.style.visibility = "hidden";
        }
      }, 200); // Increased timeout for smoother behavior
    });

    // Close other submenus when one is clicked
    detailSubMenu.addEventListener("click", function (e) {
      e.stopPropagation();
      detailsSubMenu.forEach((menu) => {
        if (menu !== detailSubMenu) {
          menu.removeAttribute("open");
          menu.querySelector(".menu-drawer__submenu").style.visibility =
            "hidden";
        }
      });
      menuDrawerSubmenu.style.visibility = "visible";
    });
  });
}

// const tabBtns = document.querySelectorAll(".collection_tab");
// const articles = document.querySelectorAll(".collection_content");

// tabBtns.forEach((btn) =>
//   btn.addEventListener("click", (e) => {
//     const id = e.target.dataset.id;
//     if (id) {
//       tabBtns.forEach((btn) => btn.classList.remove("active"));
//       e.target.classList.add("active");
//       articles.forEach((article) => article.classList.remove("active"));
//       const element = document.getElementById(id);
//       element.classList.add("active");
//     }
//   })
// );

// for Featured Collection
class TabWithContent extends HTMLElement {
  constructor() {
    super();
    // Bind the openActiveTab method to the class instance
    this.openActiveTab = this.openActiveTab.bind(this);

    // this.scrollTabs = this.scrollTabs.bind(this);
    this.scrollIndex = 0;
  }

  connectedCallback() {
    // Query tab buttons and articles within this custom element
    this.tabBtns = this.querySelectorAll(".tab_btn");
    this.articles = this.querySelectorAll(".content");

    // this.leftArrow = this.querySelector(".left-arrow");
    // this.rightArrow = this.querySelector(".right-arrow");
    this.tabsContainer = this.querySelector(".collection_tabs");

    // Attach event listeners to each tab button
    this.tabBtns?.forEach((btn) =>
      btn.addEventListener("click", this.openActiveTab)
    );

    // this.leftArrow?.addEventListener("click", this.scrollTabs);
    // this.rightArrow?.addEventListener("click", this.scrollTabs);

    // this.updateArrowVisibility();
  }

  openActiveTab(e) {
    const id = e.target.dataset.id;
    if (id) {
      // Remove active class from buttons and articles within the current section
      this.tabBtns?.forEach((btn) => btn.classList.remove("active"));
      this.articles?.forEach((article) => article.classList.remove("active"));

      // Add active class to the clicked tab and corresponding content
      e.target.classList.add("active");
      const element = this.querySelector(`#${CSS.escape(id)}`);
      element?.classList.add("active");
    }
  }
  // scrollTabs(e) {
  //    const id = e.target.dataset.id;

  //   if (this.tabBtns.length === 0) return;
  //   const direction = e.target.classList.contains("left-arrow") ? -1 : 1;
  //   // const tabWidth = this.tabBtns[0].offsetWidth;
  //   const tabWidth = this.tabBtns[0]?.offsetWidth || 0;
  //   const scrollAmount = tabWidth * direction;
  //   this.scrollIndex += direction;
  //   if (this.scrollIndex < 0) this.scrollIndex = 0;
  //   if (this.scrollIndex >= this.tabBtns.length - 1)
  //     this.scrollIndex = this.tabBtns.length - 1;

  //   this.tabsContainer.scrollBy({
  //     left: scrollAmount,
  //     behavior: "smooth",
  //   });
  //   this.updateActiveTab();
  //   this.updateArrowVisibility();
  // }

  // updateActiveTab() {

  // this.tabBtns.forEach((btn) => btn.classList.remove("active"));

  // const activeTab = this.tabBtns[this.scrollIndex];
  // if (activeTab) {
  //   activeTab.classList.add("active");
  //   const id = activeTab.dataset.id;
  //   const activeContent = this.querySelector(`#${CSS.escape(id)}`);
  //   activeContent?.classList.add("active");
  // }
  // }
  //   updateArrowVisibility() {
  //     this.tabTitle = this.querySelector(".tab-item");
  //     console.log("newwwww", this.tabTitle )
  //   // const totalWidth = this.tabBtns.length * this.tabBtns[0].offsetWidth;
  //   // const containerWidth = this.tabsContainer?.offsetWidth;
  //      const totalWidth = this.tabBtns.length * (this.tabBtns[0]?.offsetWidth || 0);
  //     const containerWidth = this.tabsContainer?.offsetWidth || 0;
  //   const maxScroll = totalWidth - containerWidth;
  //    if (this.leftArrow) {
  //     this.leftArrow.style.display = this.scrollIndex > 0 ? "block" : "none";
  //   }
  //     console.log("scrollIndex",this.scrollIndex)
  //     console.log("btnLen",this.tabBtns.length)
  //  if (this.rightArrow) {
  //     if (this.scrollIndex == this.tabBtns.length - 1 ) {
  //       this.rightArrow.style.display = "none";
  //     } else {
  //       this.rightArrow.style.display = "block";
  //     }
  //   }

  // }
}
customElements.define("tab-with-content", TabWithContent);

// document.querySelectorAll(".featured-collection").forEach((section) => {
//   const tabBtns = section.querySelectorAll(".collection_tab");
//   const articles = section.querySelectorAll(".collection_content");

//   tabBtns.forEach((btn) => btn.addEventListener("click", (e) => {}));
// });

// End Custom Drawer

/* Logo List */
const carousels = document.querySelectorAll(".logo__lists");

if (carousels) {
  carousels.forEach((carousel) => {
    new Flickity(carousel, {
      // Flickity options
      cellAlign: "left",
      contain: true,
      pageDots: false,
      groupCells: true,
      // wrapAround: true,
      responsive: {
        breakpoint: 768,
        options: {
          groupCells: 1,
        },
      },
    });
  });
}

// Slider desktop thumbnails

if (window.location.href.includes("/products/")) {
  const sliderNextBtn = document.getElementById("slider-button--next");
  const sliderPrevBtn = document.getElementById("slider-button--prev");
  const thumbnailsList = document.querySelector(".thumbnail-list");

  // Function to check and toggle button visibility
  const updateButtonVisibility = () => {
    // Check if the content is scrollable
    const isScrollable =
      thumbnailsList?.scrollHeight > thumbnailsList.clientHeight;

    if (!isScrollable) {
      // If not scrollable, hide both buttons
      sliderNextBtn.style.display = "none";
      sliderPrevBtn.style.display = "none";
    } else {
      // If scrollable, show/hide buttons based on scroll position
      if (thumbnailsList.scrollTop === 0) {
        sliderPrevBtn.style.display = "none"; // Hide previous button if at the top
      } else {
        sliderPrevBtn.style.display = "flex"; // Show previous button
      }

      if (
        thumbnailsList.scrollTop + thumbnailsList.clientHeight >=
        thumbnailsList.scrollHeight
      ) {
        sliderNextBtn.style.display = "none"; // Hide next button if at the bottom
      } else {
        sliderNextBtn.style.display = "flex"; // Show next button
      }
    }
  };

  // Event listeners for buttons
  sliderNextBtn?.addEventListener("click", () => {
    thumbnailsList.scrollTop += 200;
    updateButtonVisibility(); // Update button visibility after scroll
  });

  sliderPrevBtn?.addEventListener("click", () => {
    thumbnailsList.scrollTop -= 200;
    updateButtonVisibility(); // Update button visibility after scroll
  });

  // Initial visibility check
  document.addEventListener("DOMContentLoaded", () => {
    updateButtonVisibility(); // Check visibility on page load
  });

  // InStock Messages Product Page

  document.addEventListener("theme:variant:changed", (e) => {
    const variant = e.detail?.variant;
    const variantAvailable = variant?.available || null;
    const allVariantInventories = JSON.parse(
      document.getElementById("all_variant_inventory_quantities").textContent ||
        ""
    );
    const instockMsg = document.querySelector(".instock-msg");
    const outstockMsg = document.querySelector(".outstock-msg");
    const buttonAddtocart = document.querySelector(
      ".product-form__buttons span"
    );
    const instockWrapper = document.querySelector(".product__instock_message");
    const product_type = document.querySelector(".product_type");
    console.log("allVariantInventories", allVariantInventories[variant.id]);
    console.log("product_type ", product_type);

    if (allVariantInventories[variant.id] == 0 && variantAvailable) {
      setTimeout(() => {
        buttonAddtocart.textContent = "Place Order";
      }, 1000);
      outstockMsg.style.display = "block";
      instockMsg.style.display = "none";
      product_type.value = "made to order";

      instockWrapper.classList.remove("instock");
      instockWrapper.classList.add("outstock");
    } else {
      instockMsg.style.display = "block";
      outstockMsg.style.display = "none";
      product_type.value = "";

      instockWrapper.classList.remove("outstock");
      instockWrapper.classList.add("instock");
    }
  });
}

// whatsapp share and copy button

document.addEventListener("DOMContentLoaded", function () {
  const whatsappBtn = document.querySelector(".whatsapp");
  const copyBtn = document.querySelector(".copylink");

  let currentVariantId = null;
  const getVariantUrl = (variantId) => {
    const baseUrl = window.location.origin + window.location.pathname;
    console.log("w", window.location.origin);
    console.log("win", window.location.pathname);
    return `${baseUrl}?variant=${variantId}`;
  };
  const defaultVariantId = document.querySelector('[name="id"]')?.value;
  console.log("defaultVariantId", defaultVariantId);
  let productDetails = getVariantUrl(defaultVariantId);
  console.log("productDetails", productDetails);

  whatsappBtn?.addEventListener("click", function (e) {
    const url =
      "https://web.whatsapp.com/send?text=" +
      encodeURIComponent(productDetails);
    window.open(url, "_blank");
  });

  copyBtn?.addEventListener("click", function (e) {
    navigator.clipboard.writeText(productDetails);
    copyBtn.innerHTML = "Copied";
  });

  document.addEventListener("theme:variant:changed", (e) => {
    const variant = e.detail?.variant;
    console.log("variant", variant);
    if (!variant) return;

    currentVariantId = variant.id;
    productDetails = getVariantUrl(currentVariantId);

    copyBtn.innerHTML = "Copy";
  });
});

const fetchRequest = async (url, { method = "GET", payload = null } = {}) => {
  const customerId = ShopifyAnalytics.meta?.page?.customerId || null;
  try {
    const headers = { "Content-Type": "application/json" };
    if (customerId) headers["x-shopify-customer-id"] = customerId;

    const options = { method, headers };
    if (payload && method !== "GET" && method !== "HEAD") {
      options.body = JSON.stringify(payload);
    }

    const res = await fetch(url, options);
    const data = await res.json();

    if (!res.ok) {
      throw new Error(
        `Request failed with status ${res.status}: ${
          data.message || "Something went wrong!"
        }`
      );
    }

    return data;
  } catch (error) {
    console.error("Fetch Error:", error);
    throw error;
  }
};
// Example usage:
// For GET requests
// const wishlistData = await fetchRequest('/api/wishlist', { customerId: '123456' });

// For POST requests
// const newItem = await fetchRequest('/api/wishlist/add', {
//   method: 'POST',
//   payload: { productId: '789' },
//   customerId: '123456'
// });

// document.addEventListener("DOMContentLoaded", () => {
//   const variantInput = document.querySelector(".product-variant-id");
//   const productElement = document.querySelector(".product-wishlist");
//   const product_variant = Number(variantInput?.value);
//   const product = Number(productElement?.getAttribute("data-productId"));

//   displayWishlistCount();
// });

async function displayWishlistCount() {
  const customerId = ShopifyAnalytics.meta?.page?.customerId || null;
  const wishlistBubble = document.querySelector(".wishlist-count-bubble");

  // Get wishlistId from localStorage with proper null handling
  const wishlistIdRaw = localStorage.getItem("wishlistId");
  const wishlistId =
    wishlistIdRaw && wishlistIdRaw !== "undefined" ? wishlistIdRaw : null;

  // Clear invalid wishlist data
  if (wishlistId && !customerId) {
    localStorage.removeItem("wishlistId");
  }

  // Update count in the DOM
  const updateCountDisplay = (count) => {
    if (count > 0) {
      wishlistBubble.style.display = "flex";
      wishlistBubble.innerHTML = count;
    } else {
      wishlistBubble.style.display = "none";
    }
  };

  // Handle authenticated user with wishlist
  if (wishlistId && customerId) {
    try {
      const data = await fetchRequest(
        `https://oms-app.iqrupandritz.com/api/base/wishlists/${wishlistId}/`,
        { customerId }
      );

      const itemsCount = data?.wishlist_items?.length || 0;
      updateCountDisplay(itemsCount);
    } catch (error) {
      console.error("Error fetching wishlist:", error);
      updateCountDisplay(0);
    }
  } else {
    // Handle local storage wishlist for unauthenticated users
    const localStorageWishlistItems =
      JSON.parse(localStorage.getItem("Wishlist items")) || [];

    updateCountDisplay(localStorageWishlistItems.length);
  }
}

// Create a wishlist-button custom element
class WishlistButton extends HTMLElement {
  constructor() {
    super();
    this.fetchRequest = window.fetchRequest || this.defaultFetchRequest;
    this.wishlistName = "My Hampers";
  }

  connectedCallback() {
    this.customerId = window.ShopifyAnalytics?.meta?.page?.customerId || null;
    this.productId = Number(this.getAttribute("data-productId"));
    this.productTitle = this.getAttribute("data-title");
    this.productHandle = this.getAttribute("data-product-handle");
    this.variantId = Number(this.getAttribute("data-variant-id"));
    this.lineItemIndex = Number(this.getAttribute("data-index-id"));

    // If variant ID wasn't passed as attribute, try to find it nearby
    if (!this.variantId) {
      const variantInput = document.querySelector(".product-variant-id");
      if (variantInput) {
        this.variantId = Number(variantInput.value);
      }
    }

    // Check if product is in wishlist and update visual state
    this.updateWishlistState();

    // Add click event listener
    this.addEventListener("click", this.toggleWishlist.bind(this));

    // Listen for variant changes if on product page
    if (window.location.href.includes("/products/")) {
      document.addEventListener("theme:variant:changed", (e) => {
        const variant = e.detail?.variant;
        if (variant && variant.id) {
          this.variantId = variant.id;
          this.updateWishlistState();
        }
      });
    }
  }

  // Default fetch implementation if global one isn't available
  defaultFetchRequest = async (
    url,
    { method = "GET", payload = null } = {}
  ) => {
    try {
      const headers = { "Content-Type": "application/json" };
      if (this.customerId) headers["x-shopify-customer-id"] = this.customerId;

      const options = { method, headers };
      if (payload && method !== "GET" && method !== "HEAD") {
        options.body = JSON.stringify(payload);
      }

      const res = await fetch(url, options);
      const data = await res.json();

      if (!res.ok) {
        throw new Error(
          `Request failed with status ${res.status}: ${
            data.message || "Something went wrong!"
          }`
        );
      }

      return data;
    } catch (error) {
      console.error("Fetch Error:", error);
      throw error;
    }
  };

  getLocalWishlist() {
    return JSON.parse(localStorage.getItem("Wishlist items")) || [];
  }

  updateLocalWishlist(items) {
    localStorage.setItem("Wishlist items", JSON.stringify(items));
  }

  toggleWishlistIcon(active) {
    const icon = this.querySelector(".icon--wishlist");
    if (icon) {
      icon.classList.toggle("is-active", active);
    }
  }

  get wishlistItem() {
    return {
      product: this.productId,
      product_variant: this.variantId,
      quantity: 1,
      metadata: {
        title: this.productTitle,
        handle: this.productHandle,
      },
    };
  }

  get wishlistHamper() {
    return {
      name: this.wishlistName,
      wishlist_items: [this.wishlistItem],
    };
  }

  async updateWishlistState() {
    if (!this.productId || !this.variantId) return;

    const wishlistIdRaw = localStorage.getItem("wishlistId");
    const wishlistId =
      wishlistIdRaw && wishlistIdRaw !== "undefined" ? wishlistIdRaw : null;

    if (wishlistId && this.customerId) {
      try {
        const data = await this.fetchRequest(
          `https://oms-app.iqrupandritz.com/api/base/wishlists/${wishlistId}/`
        );

        const currentItems = data.wishlist_items || [];
        const alreadyExists = currentItems.some(
          (item) =>
            item.product === this.productId &&
            item.product_variant === this.variantId
        );

        this.toggleWishlistIcon(alreadyExists);
      } catch (error) {
        console.log("API Error:", error);
        this.checkLocalWishlistState();
      }
    } else {
      this.checkLocalWishlistState();
    }
  }

  checkLocalWishlistState() {
    const localItems = this.getLocalWishlist();
    const existsInLocal = localItems.some(
      (item) =>
        item.product === this.productId &&
        item.product_variant === this.variantId
    );
    this.toggleWishlistIcon(existsInLocal);
  }

  async toggleWishlist() {
    if (!this.productId || !this.productHandle || !this.variantId) return;

    let localItems = this.getLocalWishlist();
    const existsInLocal = localItems.some(
      (item) =>
        item.product === this.productId &&
        item.product_variant === this.variantId
    );

    if (existsInLocal) {
      localItems = localItems.filter(
        (item) =>
          !(
            item.product === this.productId &&
            item.product_variant === this.variantId
          )
      );
      this.updateLocalWishlist(localItems);
      this.toggleWishlistIcon(false);
    } else {
      localItems.push(this.wishlistItem);
      this.updateLocalWishlist(localItems);
      this.toggleWishlistIcon(true);
    }

    if (this.customerId) {
      try {
        const res = await this.fetchRequest(
          "https://oms-app.iqrupandritz.com/api/base/wishlists/"
        );
        const wishlists = res.results || [];
        const existingWishlist = wishlists.find(
          (w) => w.name === this.wishlistName
        );

        if (existingWishlist) {
          localStorage.setItem("wishlistId", existingWishlist.id);
          const detail = await this.fetchRequest(
            `https://oms-app.iqrupandritz.com/api/base/wishlists/${existingWishlist.id}/`
          );
          const currentItems = detail.wishlist_items || [];

          const alreadyExists = currentItems.some(
            (item) =>
              item.product === this.productId &&
              item.product_variant === this.variantId
          );

          if (alreadyExists) {
            const updatedItems = currentItems.filter(
              (item) =>
                !(
                  item.product === this.productId &&
                  item.product_variant === this.variantId
                )
            );

            await this.fetchRequest(
              `https://oms-app.iqrupandritz.com/api/base/wishlists/${existingWishlist.id}/`,
              {
                method: "PUT",
                payload: {
                  name: this.wishlistName,
                  wishlist_items: updatedItems,
                },
              }
            );

            this.toggleWishlistIcon(false);
          } else {
            const updatedItems = [...currentItems, this.wishlistItem];
            await this.fetchRequest(
              `https://oms-app.iqrupandritz.com/api/base/wishlists/${existingWishlist.id}/`,
              {
                method: "PUT",
                payload: {
                  name: this.wishlistName,
                  wishlist_items: updatedItems,
                },
              }
            );

            this.toggleWishlistIcon(true);
          }
        } else {
          const created = await this.fetchRequest(
            "https://oms-app.iqrupandritz.com/api/base/wishlists/",
            {
              method: "POST",
              payload: this.wishlistHamper,
            }
          );

          localStorage.setItem("wishlistId", created.id);
          this.toggleWishlistIcon(true);
        }
      } catch (err) {
        console.error("Wishlist API error:", err);
      }
    }

    document.dispatchEvent(
      new CustomEvent("wishlist:added", {
        detail: {
          cartItemIndex: this.lineItemIndex,
        },
      })
    );
  }
}

customElements.define("wishlist-button", WishlistButton);

document.addEventListener("DOMContentLoaded", () => {
  displayWishlistCount();
});

document.addEventListener("wishlist:added", (e) => {
  displayWishlistCount();

  const cartItemIndex = e?.detail?.cartItemIndex;
  if (cartItemIndex) {
    removeWishListFromCart(cartItemIndex, 0);
  }
});

function removeWishListFromCart(line, quantity) {
  const body = JSON.stringify({
    line: line,
    quantity: quantity,
  });

  fetch(window.Shopify.routes.root + "cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: body,
  })
    .then((response) => response.json())
    .then((data) => {
      window.location.reload();
    })
    .catch((error) => {
      console.error("Error updating cart:", error);
    });
}
